import emitter from '@/mixins/emitter'

export default {
  mixins: [emitter],
  data() {
    return {}
  },
  methods: {
    openGlobalPreviewMedia(media) {
      this.dispatch(
        'GlobalPreviewMediaDialog',
        'open-global-preview-media',
        media,
        'global-preview-media-dialog',
      )
    },
    closeGlobalPreviewMedia() {
      this.dispatch(
        'GlobalPreviewMediaDialog',
        'close-global-preview-media',
        null,
        'global-preview-media-dialog',
      )
    },
  },
}
